module.exports = __webpack_public_path__ + "fonts/SofiaProLight-Italic.06d1480f.eot";